import type { PendingBackgroundExecution } from '../../store/backgroundExecutionStore';

export const listThreadsWaitingForInput = ({
  executions,
  applicationId,
}: {
  executions: Iterable<PendingBackgroundExecution>;
  applicationId: string;
}): string[] => [
  ...new Set(
    [...executions]
      .filter(
        (execution) =>
          execution.applicationId === applicationId &&
          execution.waitingInput === true &&
          !execution.terminalStatus,
      )
      .sort((left, right) => (right.trackedAt ?? 0) - (left.trackedAt ?? 0))
      .map((execution) => execution.copilotThreadId),
  ),
];
